import * as React from 'react'
import { IPromise } from 'angular'
import { reactular } from '@vendhq/reactular'
import {
  Box,
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import { $q } from '../../../../ng-compat/imports'
import { SERVICE_REFUND_ACTIONS } from '../../../../util/types'

interface Props {
  close: (val?: IPromise<any>) => void
}

export const ServiceSaleRefundModal: React.FC<Props> = ({ close }) => {
  const closeAngularModal = () => {
    close($q.resolve())
  }

  const dismissServiceSaleRefund = () => {
    close($q.resolve(SERVICE_REFUND_ACTIONS.DISMISS))
  }
  const continueServiceSaleRefund = () => {
    close($q.resolve(SERVICE_REFUND_ACTIONS.REFUND))
  }

  return (
    <Modal onClose={closeAngularModal}>
      <ModalHeader>Refund customer?</ModalHeader>
      <ModalContent>
        <Text tag="p" className="vd-mt2">
          If you issue a refund, you will no longer be able to modify this sale.
          Continue to refund or discard changes.
        </Text>
      </ModalContent>
      <ModalActions>
        <Box className="vd-btn-group">
          <Button
            variant="supplementary"
            onClick={() => {
              dismissServiceSaleRefund()
            }}
          >
            Discard changes
          </Button>
          <Button variant="no" onClick={() => continueServiceSaleRefund()}>
            Continue to refund
          </Button>
        </Box>
      </ModalActions>
    </Modal>
  )
}

ServiceSaleRefundModal.displayName = 'ServiceSaleRefundModal'

export const ServiceSaleRefundModalComponent = reactular(
  ServiceSaleRefundModal,
  ['close'],
  'reactWrapper'
)
